import { Crown, Zap } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");

const Stat = ({ label, value, testid }) => (
  <div className="space-y-1">
    <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div className="font-bold" data-testid={testid}>{value}</div>
  </div>
);

export const SubscriptionStatus = ({ usage }) => {
  const premium = usage.plan === "premium";
  const pct = usage.limit ? Math.round((usage.remaining / usage.limit) * 100) : 0;
  return (
    <section className="panel p-6 space-y-5" data-testid="subscription-status">
      <div className="flex items-center gap-2 font-bold">
        {premium ? <Crown className="h-5 w-5 text-amber-400" /> : <Zap className="h-5 w-5 text-primary" />}
        <span data-testid="subscription-plan-name">{premium ? `${usage.plan_name} plan` : "Free trial"}</span>
        <span className={`ml-auto text-[11px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1 ${premium ? "bg-emerald-500/15 text-emerald-400" : "bg-secondary text-muted-foreground"}`} data-testid="subscription-state">
          {premium ? "Active" : usage.remaining > 0 ? "Trial" : "No active plan"}
        </span>
      </div>
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span>Generations left</span>
          <span className="font-bold" data-testid="subscription-remaining">{usage.remaining.toLocaleString()} / {usage.limit.toLocaleString()}</span>
        </div>
        <div className="h-2 rounded-full bg-secondary overflow-hidden"><div className="h-full brand-gradient transition-all" style={{ width: `${pct}%` }} /></div>
      </div>
      {premium && (
        <div className="grid grid-cols-2 gap-4">
          <Stat label="Started" value={fmt(usage.started_at)} testid="subscription-start" />
          <Stat label="Expires" value={fmt(usage.premium_until)} testid="subscription-expiry" />
        </div>
      )}
      {!premium && usage.remaining === 0 && <p className="text-sm text-amber-300" data-testid="subscription-choose-plan">Your free generations are used up. Choose a plan below to keep going.</p>}
    </section>
  );
};
